import { parseBoolean } from '@tb-core/helpers/utils/parse-boolean';

export const appleItunesId = process.env.APPLE_ITUNES_ID || '';
export const assetPath = process.env.ASSET_PATH || '';
export const basePath = process.env.BASE_PATH || '';
export const brazeEnabled = process.env.BRAZE_ENABLED || '';
export const brazeHost = process.env.BRAZE_HOST || '';
export const brazeKey = process.env.BRAZE_KEY || '';
export const contentfulEnv = process.env.CTF_ENV || '';
export const contentfulHost = process.env.CTF_HOST || '';
export const contentfulSpace = process.env.CTF_SPACE_ID || '';
export const contentfulToken = process.env.CTF_TOKEN || '';
export const cscEnabled: boolean = parseBoolean(process.env.CSC_ENABLED || '');
export const dataDogEnv = process.env.DATA_DOG_ENV || '';
export const dataPath = process.env.DATA_PATH || '';
export const envId = process.env.ENV_ID || '';
export const facebookAppId = process.env.FACEBOOK_APP_ID || '';
export const firebaseApiKey = process.env.FIREBASE_API_KEY || '';
export const firebaseAppId = process.env.FIREBASE_APP_ID || '';
export const firebaseAuthDomain = process.env.FIREBASE_AUTH_DOMAIN || '';
export const firebaseDBUrl = process.env.FIREBASE_DB_URL || '';
export const firebaseMeasurementId = process.env.FIREBASE_MEASUREMENT_ID || '';
export const firebaseMessagingSenderId =
    process.env.FIREBASE_MESSAGING_SENDER_ID || '';
export const firebaseProjectId = process.env.FIREBASE_PROJECT_ID || '';
export const firebaseStorageBucket = process.env.FIREBASE_STORAGE_BUCKET || '';
export const googleGaId = process.env.GA_ID || '';
export const googleGaGlobalId = process.env.GA_GLOBAL_ID || '';
export const googleGtmId = process.env.GTM_ID || '';
export const googleMapsUrl = process.env.GOOGLE_MAPS_URL || '';
export const googlePayAuthMethods = process.env.GOOGLE_PAY_AUTH_METHODS || '';
export const googlePayEnv = process.env.GOOGLE_PAY_ENV || '';
export const googlePayGatewayMerchantId =
    process.env.GOOGLE_PAY_GATEWAY_MERCHANT_ID || '';
export const googlePayGatewayName = process.env.GOOGLE_PAY_GATEWAY_NAME || '';
export const googlePayMerchantId = process.env.GOOGLE_PAY_MERCHANT_ID || '';
export const googlePayMerchantName = process.env.GOOGLE_PAY_MERCHANT_NAME || '';
export const googlePayMethod = process.env.GOOGLE_PAY_PAYMENT_METHOD || '';
export const googlePaySupportedCards =
    process.env.GOOGLE_PAY_SUPPORTED_CARDS || '';
export const googlePlayId = process.env.GOOGLE_PLAY_ID || '';
export const host = process.env.API_HOST || '';
export const nextApiBasePath = process.env.NEXT_API_BASE_PATH || '';
export const nextApiHost = process.env.NEXT_API_HOST || '';
export const routes: any[] = JSON.parse(process.env.ROUTES || '[]');
export const serverlessApiUrl = process.env.SERVERLESS_API_URL || '';
export const serviceBasePath = process.env.SERVICE_BASE_PATH || '';
export const serviceUrl = process.env.SERVICE_URL || '';
export const shopifyDomain = process.env.SHOPIFY_DOMAIN || '';
export const shopifyToken = process.env.SHOPIFY_TOKEN || '';
export const storeNationalId = process.env.STORE_NATIONAL_ID || '';
export const subscribeEmailApiKey = process.env.SUBSCRIBE_EMAIL_API_KEY || '';
export const subscribeEmailApiUrl = process.env.SUBSCRIBE_EMAIL_API_URL || '';
export const testingBearerToken = process.env.TESTING_BEARER_TOKEN || '';
export const webFixedVersion = process.env.WEB_FIXED_VERSION || '';
export const webOrigin = process.env.WEB_ORIGIN || '';

export type NextEnvProps = {
    [P in keyof typeof NextEnv]?: typeof NextEnv[P];
};

const NextEnv = {
    appleItunesId,
    assetPath,
    basePath,
    brazeEnabled,
    brazeHost,
    brazeKey,
    contentfulEnv,
    contentfulHost,
    contentfulSpace,
    contentfulToken,
    cscEnabled,
    dataDogEnv,
    dataPath,
    facebookAppId,
    firebaseApiKey,
    firebaseAppId,
    firebaseAuthDomain,
    firebaseDBUrl,
    firebaseMeasurementId,
    firebaseMessagingSenderId,
    firebaseProjectId,
    firebaseStorageBucket,
    googleGaGlobalId,
    googleGaId,
    googleGtmId,
    googleMapsUrl,
    googlePayAuthMethods,
    googlePayEnv,
    googlePayGatewayMerchantId,
    googlePayGatewayName,
    googlePayMerchantId,
    googlePayMerchantName,
    googlePayMethod,
    googlePaySupportedCards,
    googlePlayId,
    host,
    nextApiBasePath,
    nextApiHost,
    routes,
    serverlessApiUrl,
    serviceBasePath,
    serviceUrl,
    shopifyDomain,
    shopifyToken,
    storeNationalId,
    subscribeEmailApiKey,
    subscribeEmailApiUrl,
    testingBearerToken,
    webOrigin
};

export default NextEnv;
